(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/game-limits-deposits-form/assets/service/deposit-limits-service.js') >= 0) return;  svs.modules.push('/components/accountservices-react/game-limits-deposits-form/assets/service/deposit-limits-service.js');
'use strict';

const isServer = typeof exports === 'object';
let logger;
let jupiter;
if (isServer) {
  const trinidad = require('@svenskaspelab/trinidad-core').core;
  jupiter = trinidad.jupiter;
  logger = trinidad.logger('game-limits-deposits-form');
} else {
  jupiter = svs.core.jupiter;
  logger = svs.accountservicesReact.logger;
}

const cleanResponse = response => {
  const cleaned = Object.assign({}, response);
  delete cleaned.requestId;
  delete cleaned.deviceId;
  delete cleaned.requestInfo;
  return cleaned;
};

const getDepositLimitsAsync = async req => {
  const path = '/player/2/depositlimits';
  try {
    let response;
    let status;
    const options = {
      method: 'GET',
      path,
      data: {},
      req
    };
    if (isServer) {
      const apiResponse = await jupiter.callAsync(options);
      status = apiResponse ? 'success' : 'error';
      response = Boolean(apiResponse) && apiResponse;
    } else {
      var _await$jupiter$callAs = await jupiter.callAsync(options);
      response = _await$jupiter$callAs.response;
      status = _await$jupiter$callAs.status;
    }
    return {
      error: status === 'success' ? null : 'error',
      data: status === 'success' ? cleanResponse(response) : {}
    };
  } catch (err) {
    logger.info("Error Getting customer deposit limits ".concat(path), err);
    return {
      error: err,
      data: {}
    };
  }
};

const setDepositLimitAsync = async (limitTypesArray, depositBudgetsArray) => {
  const makeApiCall = async path => {
    const options = {
      method: 'PUT',
      path,
      data: {
        limitTypes: limitTypesArray,
        depositBudgets: depositBudgetsArray
      }
    };
    return jupiter.callAsync(options);
  };
  const primaryPath = '/gamblingcare/1/gamelimits/deposit';
  const fallbackPath = '/player/2/depositlimits';
  try {
    const _await$makeApiCall = await makeApiCall(primaryPath),
      response = _await$makeApiCall.response,
      status = _await$makeApiCall.status;
    if (status === 'success') {
      return {
        error: null,
        data: cleanResponse(response)
      };
    }
  } catch (err) {
    logger.info("Primary path failed: ".concat(primaryPath), err);
  }
  try {
    const _await$makeApiCall2 = await makeApiCall(fallbackPath),
      response = _await$makeApiCall2.response,
      status = _await$makeApiCall2.status;
    return {
      error: status === 'success' ? null : 'error',
      data: status === 'success' ? cleanResponse(response) : {}
    };
  } catch (err) {
    logger.error("Fallback path failed: ".concat(fallbackPath), err);
    return {
      error: err,
      data: {}
    };
  }
};

if (isServer) {
  exports.getDepositLimitsAsync = getDepositLimitsAsync;
} else {
  svs.accountservicesReact.gameLimitDepositsForm.service = {
    getDepositLimitsAsync,
    setDepositLimitAsync
  };
}

 })(window);